import * as React from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
export var stripSpaces = function (str) {
    return str.replace(/\s/g, '');
};
export var ErrorMsg = function (props) {
    return (React.createElement(CSSTransitionGroup, { className: 'error-msg-container', transitionName: 'appear', transitionAppearTimeout: 200, transitionEnterTimeout: 200, transitionLeaveTimeout: 200 }, props.isVisible ? React.createElement("span", { role: 'alert', className: 'error-msg' }, props.msg) : null));
};
export var Spinner = function () { return (React.createElement("div", { className: 'spinner' },
    React.createElement("div", { className: 'bounce1' }),
    React.createElement("div", { className: 'bounce2' }),
    React.createElement("div", { className: 'bounce3' }))); };
export var delay = function (retryDelay) { return new Promise(function (res) { return setTimeout(res, retryDelay); }); };
//# sourceMappingURL=contact-form-utils.js.map